import { Button, Dialog, DialogContent, Grid, IconButton, Slide, Typography } from '@mui/material';
import { forwardRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import perfectRxTheme from 'common/theme/perfectRxTheme';
import DateRangePickerField from 'common/forms/DateRangePickerField';
import { useDispatch, useSelector } from 'react-redux';
import { filterBulkLabelHistory } from 'store/thunks/workQueueThunks';
import BulkLabelPrintHistoryTable from './BulkLabelPrintHistoryTable';
import BulkLabelPrintHistoryFilterButton from './BulkLabelPrintHistoryFilterButton';
import BulkLabelPrintHistoryFilterStatusBar from './BulkLabelPrintHistoryFilterStatusBar';

const Transition = forwardRef((props, ref) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Slide direction='up' ref={ref} {...props} timeout={300} />
));

const BulkLabelPrintHistoryButton = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const handleBulkLabelPrintHistoryButton = () => setOpen(true);
  const closeDialog = () => setOpen(false);

  const filter = useSelector(
    ({
      workQueue: {
        bulkLabels: { bulkLabelHistory },
      },
    }) => ({
      ...bulkLabelHistory.filter,
    })
  );

  const onHandleDateChange = (dateRange) => {
    dispatch(
      filterBulkLabelHistory({
        filter: {
          ...filter,
          createdBetween:
            dateRange.length === 1
              ? { fromDate: dateRange[0], toDate: dateRange[0] }
              : { fromDate: dateRange[0], toDate: dateRange[1] },
        },
      })
    );
  };

  return (
    <>
      <Button variant='contained' color='primary' onClick={handleBulkLabelPrintHistoryButton}>
        Print History
      </Button>
      <Dialog
        open={open}
        aria-describedby='Bulk-Label-Print-History'
        fullScreen
        TransitionComponent={Transition}
      >
        <Grid
          container
          sx={{ px: 2, p: 1, bgcolor: 'primary.light' }}
          justifyContent='space-between'
          alignItems='center'
        >
          <Grid
            container
            sx={{ px: 2, p: 1, bgcolor: 'primary.light' }}
            justifyContent='space-between'
            alignItems='center'
          >
            <Typography component='h2' variant='h6' color={perfectRxTheme.palette.text.light}>
              Bulk Label Print History
            </Typography>

            <IconButton onClick={closeDialog} aria-label='Close Dialog'>
              <CloseIcon style={{ color: perfectRxTheme.palette.text.light }} />
            </IconButton>
          </Grid>
        </Grid>

        <DialogContent id='Bulk-Label-Print-History'>
          <Grid container direction='column' spacing={2}>
            <Grid item>
              <Grid container justifyContent='space-between' alignItems='center'>
                <Grid item>
                  <BulkLabelPrintHistoryFilterStatusBar />
                </Grid>

                <Grid item>
                  <Grid container spacing={1} alignItems='center'>
                    <Grid item>
                      <DateRangePickerField
                        label='Date Range'
                        onDateChange={onHandleDateChange}
                        initialValue={
                          filter?.createdBetween?.fromDate
                            ? [
                                filter?.createdBetween?.fromDate,
                                ...(filter?.createdBetween?.toDate &&
                                filter?.createdBetween?.toDate !== filter?.createdBetween?.fromDate
                                  ? [filter?.createdBetween?.toDate]
                                  : []),
                              ]
                            : null
                        }
                      />
                    </Grid>

                    <Grid item>
                      <BulkLabelPrintHistoryFilterButton />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <BulkLabelPrintHistoryTable />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default BulkLabelPrintHistoryButton;
